import { Diagram, GraphObject, HTMLInfo, Link } from 'gojs';
import { OrchestrationGoJsCommandHandler } from '../../../utils/orchestration-gojs-command-handler';

const $ = GraphObject.make;

export const OrchestrationLinkContextMenu = () =>
  $(HTMLInfo, {
    show: (obj: GraphObject, diagram: Diagram) => {
      const { x, y } = diagram.lastInput.viewPoint;
      const commandHandler = diagram.commandHandler as OrchestrationGoJsCommandHandler;
      commandHandler.showCustomContextMenu(
        {
          position: { x, y },
          items: [
            {
              label: 'Delete Link',
              icon: ['fal', 'trash'],
              callback: () => commandHandler.deleteLink(obj.part as Link),
            },
          ],
        },
        diagram,
      );
    },
    hide: (diagram: Diagram) => {
      const commandHandler = diagram.commandHandler as OrchestrationGoJsCommandHandler;
      commandHandler.hideCustomContextMenu();
    },
  });
